export const STORAGE_KEY = 'ie-user-data';
export const REMEMBER_ME_KEY = 'ie-remember-me';
export const EXPIRATION_BUFFER_MS = 10000;
